import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Programs, Products, Features, Feature, Flows, ProdLimit } from 'bff/models/product';
import { Inscats, Inscat, Codes, Activities, Activity, Bulletin, Recommands, RecommandData } from 'bff/models/info';
import { InsType } from 'constants/enums/insType.enum';
import _ from 'lodash';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Links, CarProdLink } from 'bff/models/link';
import { BulletinType } from 'constants/enums/bulletinType.enum';
import { ProdLimitId } from 'constants/enums/prodLimitId.enum';

/**
 * @description 取得汽車險商品首頁初始化資料
 * @param programId 專案代碼
 */
const fetchInitSetting = async (programId:string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const programIdReq = commonService.getApiReqData({ PROGRAM_ID: programId || '' });
  const carLmtReq = commonService.getApiReqData({ INS_TYPE_ID: InsType.Car, LIMIT_ID: `${ProdLimitId.CARLMT},${ProdLimitId.CARBODY}` });
  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchProgramByInsTypeId(programIdReq, reqConfig, InsType.Car),
    apiService.fetchProductByInsTypeId(baseReq, reqConfig, InsType.Car),
    apiService.fetchFeatureByInsTypeId(baseReq, reqConfig, InsType.Car),
    apiService.fetchFlowByInsTypeId(baseReq, reqConfig, InsType.Car),

    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CREDITCARD_BANK),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, InsType.Car),
    apiService.fetchLinkByCategory(baseReq, reqConfig, InsType.Car),
    apiService.fetchAnnounces(baseReq, reqConfig, BulletinType.InsType, InsType.ECar),

    apiService.fetchProdLimit(carLmtReq, reqConfig),
    apiService.fetchRecommands(baseReq, reqConfig, InsType.Car)
  ]).then(([
    inscatsRes, programsRes, productsRes, featuresRes, flowsRes,
    creditCardCodeRes, UICodeRes, activitiesRes, serviceLinksRes, bulletinRes,
    carLmtRes, carRecommandsRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };
    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === InsType.ECar) as Inscat;
    const programsBaseRes:BaseRes<Programs> = { ...programsRes };
    const productsBaseRes:BaseRes<Products> = { ...productsRes };
    const featuresBaseRes:BaseRes<Features> = { ...featuresRes };
    const flowsBaseRes:BaseRes<Flows> = { ...flowsRes };

    const creditCardCodeBaseRes:BaseRes<Codes> = { ...creditCardCodeRes };
    const uiCodeBaseRes:BaseRes<Codes> = { ...UICodeRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const serviceLinksBaseRes:BaseRes<Links<CarProdLink>> = { ...serviceLinksRes };
    const bulletinBaseRes:BaseRes<Bulletin> = { ...bulletinRes };

    const carLmtBaseRes:BaseRes<ProdLimit> = { ...carLmtRes };
    const carRecommandsBaseRes:BaseRes<Recommands> = { ...carRecommandsRes };

    const res = {
      inscat: { ...inscatRes },
      programs: commonService.arrayTypeReturn(programsBaseRes.TRANRS.PROGRAMS),
      products: commonService.arrayTypeReturn(productsBaseRes.TRANRS.PRODUCT),
      features: featuresBaseRes.TRANRS.FEATURE ? [...featuresBaseRes.TRANRS.FEATURE.sort((first:Feature, second:Feature) => first.SHOW_ORDER - second.SHOW_ORDER)] : new Array(0),
      flows: commonService.arrayTypeReturn(flowsBaseRes.TRANRS.FLOWS),

      creditCardCode: commonService.arrayTypeReturn(creditCardCodeBaseRes.TRANRS.CODES),
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      },
      serviceLinks: serviceLinksBaseRes.TRANRS.LINKS ? [...serviceLinksBaseRes.TRANRS.LINKS.I02] : new Array(0),
      bulletin: bulletinBaseRes.TRANRS.BULLETIN ? { ...bulletinBaseRes.TRANRS } : { BULLETIN: {} } as Bulletin,
      uiCode: commonService.arrayTypeReturn(uiCodeBaseRes.TRANRS.CODES),

      carLmt: [...carLmtBaseRes.TRANRS.CARLMT],
      carBodyLmt: [...carLmtBaseRes.TRANRS.CARBODY],
      carRecommands: carRecommandsBaseRes.TRANRS.RECOMMANDS ? carRecommandsBaseRes.TRANRS.RECOMMANDS.find((recommandData: RecommandData) => recommandData.INS_TYPE_ID === InsType.Car) : {}
    };

    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
